import { useUserStateContext } from '@/shared/components/UserStateProvider';

/**
 * The permission every write on the Resources page already answers to.
 *
 * `menu:games:resources` opens the page; this is what the five launch/cleanup
 * POSTs behind it are gated on in ROUTE_ROLES_CONFIG. Reusing the endpoint's own
 * role rather than minting a `ui:games:resources:*` twin is the rule the role
 * catalog states for itself: a parallel UI name for something that maps 1:1 to
 * an endpoint is a second thing to keep in sync, and the two drift apart the
 * first time only one of them is granted.
 */
export const RESOURCES_WRITE_ROLE = 'write:games:resources';

/**
 * Whether this user may act on resources, as opposed to only watching them.
 *
 * The API has always drawn this line — a read-only user's launch POST comes
 * back 403 — so the UI is catching up to a distinction that already exists
 * rather than inventing one. Without it the page offers buttons that are
 * guaranteed to fail, which reads as a broken launch rather than as a
 * permission the user does not hold.
 */
export function useCanEditResources(): boolean {
  const { hasRole } = useUserStateContext();
  return hasRole(RESOURCES_WRITE_ROLE);
}
